import { Divider } from '@moonjellydigital/react-components';
import { ArtworkDisplayFetchWrapper } from '@sheridan-prize/ui';
import { createFileRoute } from '@tanstack/react-router';
import { Pane } from '@sheridan-prize/ui';
import { SpSidebar } from '../components/Sidebar';

export const Route = createFileRoute('/artworks-preview_/$artworkId')({
  component: RouteComponent,
});

function RouteComponent() {
  const { artworkId } = Route.useParams();

  return (
    <>
      <SpSidebar />
      <Pane tag="main" classes={'sp-main'}>
        <h1>Previewing Artwork</h1>
        <Divider semantic={false} orientation="horizontal" />
        <ArtworkDisplayFetchWrapper artworkId={artworkId} />
      </Pane>
    </>
  );
}
